import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';
import { closeModal } from 'components/Modal';
import Message from 'components/Message';
import When from 'components/When';
import appMessages from 'features/App/App.messages';
import messages from '../ReservationFeedbackModalV2.messages';
import UserProfile from '../UserProfile';

import './ReportDetailsHeader.scss';

const { block, element } = bem('report-details-header');

const ReportDetailsHeader = ({ fullName, profileUrl, isMobile }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const closeAriaLabel = intl.formatMessage(appMessages.close);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <div className={block()}>
      <When predicate={isMobile}>
        <div className={element('close-button')}>
          <button
            type="button"
            onClick={handleClose}
            name="close-button"
            aria-label={closeAriaLabel}
            className={element('close-icon')}>
            <Isvg src={ICONS.cross} />
          </button>
        </div>
      </When>
      <Message className={element('title')} message={messages.reportDetailsTitle} />
      <div className={element('reporting-section')}>
        <UserProfile fullName={fullName} profileUrl={profileUrl} />
      </div>
    </div>
  );
};

ReportDetailsHeader.propTypes = {
  fullName: PropTypes.string.isRequired,
  profileUrl: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
};

export default ReportDetailsHeader;
